<template>
  <el-form class="entrance-exam-form" label-position="top">
    <el-form-item label="Trung tâm" required>
      <el-select
        :value="centerId"
        class="w-100 entrance-exam-select"
        :class="{ 'is-filled': centerId }"
        placeholder="Chọn trung tâm"
        filterable
        :loading="loadingCenters"
        popper-class="entrance-exam-select-dropdown"
        @input="onChange"
      >
        <el-option
          v-for="item in centers"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "ScheduleCenterStep",
  props: {
    centers: {
      type: Array,
      default: () => []
    },
    centerId: {
      default: null
    },
    loadingCenters: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onChange(val) {
      this.$emit("update:centerId", val);
    }
  }
};
</script>

